import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import CurrencyAmountInput from "./CurrencyAmountInput";

export const PaymentModal = ({
	t,
	show,
	onHide,
	paymentData,
	onPaymentDataChange,
	paidType,
	onPaidTypeChange,
	customerType,
	errors,
	handleSave,
	getCurrencySymbol,
	disableScrollProps,
	totals,
	handleSettlePayment,
	convertCurrency,
	defaultCurrency
}) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton style={{ backgroundColor: "#dbffe5", borderColor: "#1b255b" }}>
				<Modal.Title style={{ color: "#1b255b" }}>
					<i className="fa fa-money me-2" />
					{t("Payment Process")}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group className="mb-3">
						<Form.Label>{t("Payment Type")}</Form.Label>
						<Form.Select
							value={paymentData.type}
							onChange={(event) => onPaymentDataChange({ type: event.target.value })}
							isInvalid={!!errors.type}
						>
							<option value="cash">{t("Cash")}</option>
							<option value="card">{t("Card")}</option>
							<option value="upi">{t("UPI")}</option>
						</Form.Select>
						<Form.Control.Feedback type="invalid">{errors.type}</Form.Control.Feedback>
					</Form.Group>
					{customerType !== "walking" && (
						<Form.Group className="mb-3">
							<Form.Label>{t("Payment")}</Form.Label>
							<Row>
								<Col sm="6" className="mb-2">
									<div className="radio radio-primary">
										<Input
											id="paid-type-full"
											type="radio"
											name="paidType"
											value="full"
											checked={paidType === "full"}
											onChange={() => onPaidTypeChange("full")}
										/>
										<Label for="paid-type-full" className="ps-3">
											{t("Full Paid")}
										</Label>
									</div>
								</Col>
								<Col sm="6" className="mb-2">
									<div className="radio radio-primary">
										<Input
											id="paid-type-partial"
											type="radio"
											name="paidType"
											value="partial"
											checked={paidType === "partial"}
											onChange={() => onPaidTypeChange("partial")}
										/>
										<Label for="paid-type-partial" className="ps-3">
											{t("Partial Paid")}
										</Label>
									</div>
								</Col>
							</Row>
						</Form.Group>
					)}
					{/* <Form.Group className="mb-3">
					<Form.Label>{t("Amount")}</Form.Label>
					<Form.Control
						type="number"
						value={paymentData.amount}
						onChange={(event) => onPaymentDataChange({ amount: event.target.value })}
						isInvalid={!!errors.amount}
						disabled={paidType === "full"}
						{...disableScrollProps}
					/>
					<Form.Control.Feedback type="invalid">{errors.amount}</Form.Control.Feedback>
				</Form.Group> */}
					{totals.netTotal ? (
						<div>
							{t("Total Amount")}:
							<span className="text-muted small">
								{getCurrencySymbol(paymentData.currency)}
								{convertCurrency(totals.netTotal, defaultCurrency, paymentData.currency).toFixed(2)}

							</span>
						</div>
					) : null}
					<CurrencyAmountInput
						label={t("Paid")}
						amount={paymentData.amount}
						onAmountChange={(value) => onPaymentDataChange({ amount: value })}
						onCurrencyChange={(cur) => onPaymentDataChange({ currency: cur })}
						disabled={paidType === "full"}
						errors={errors}
						disableScrollProps={disableScrollProps}
						defaultCurrency={defaultCurrency}
						originalAmount={totals.netTotal}
					/>
				</Form>
				<div className="p-2 my-3 d-flex justify-content-end flex-column payment-info bg-primary-subtle">
					<div className="mb-1">
						<strong>{t("Payment")}:</strong>{" "}
						{paidType === "full" ? t("Full Paid") : t("Partial Paid")}
						{paidType === "partial" && (
							<span className="ms-3 text-danger">
								{t("Remaining")}: {getCurrencySymbol(paymentData.currency)}
								{(() => {
									// Convert total from INR → selected currency
									const convertedTotal = convertCurrency(totals.netTotal, defaultCurrency, paymentData.currency);

									const remaining = Math.max(0, convertedTotal - Number(paymentData.amount || 0));
									return remaining.toFixed(2);
								})()}
							</span>

						)}
					</div>
					<p>
						<strong>{t("Payment Amount")}:</strong> {getCurrencySymbol(paymentData.currency)}
						{Number(paymentData.amount).toFixed(2) || 0}
					</p>
				</div>
				{customerType === "inpatient" && paidType === "partial" && (
					<Col sm="6" className="mb-2">
						<div className="checkbox checkbox-solid-light" style={{ display: "flex", alignItems: "center" }}>
							<Input
								id="isSettle-checkbox"
								type="checkbox"
								checked={paymentData.isSettle}
								className="me-2"
								onChange={handleSettlePayment}
							/>
							<label htmlFor="isSettle-checkbox" style={{ fontSize: "14px", margin: 0 }}>
								<strong>{t("Payment Settlement")}</strong>
							</label>
						</div>
					</Col>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={handleSave}>
					{t("Generate Bill")}
				</Button>
				<Button variant="secondary" onClick={onHide}>
					{t("Cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default PaymentModal;

